export const SURVEY_PARTICIPANTS_CONFIG = {
	VIEW_TYPES: {
		ALL_EMPLOYEES: "all-employees",
		SELECT_PARTICIPANTS: "select-participants",
		PARTICIPANTS: "participants",
	} as const,

	SURVEY_ACCESS: {
		ALL_EMPLOYEES: "all-employees",
		SELECTED_EMPLOYEES: "selected-employees",
	} as const,

	SELECTION_CONFIG: {
		PAGE: 1,
		SORT_FIELD: "name",
		SORT_DIRECTION: "asc",
		LIMIT: 25,
	},

	UI_CONFIG: {
		CONTAINER_HEIGHT: "62dvh",
		SELECTION_HEIGHT: "56dvh",
		PLACEHOLDER_HEIGHT: "calc(100vh-260px)",
	},
} as const;

export type ViewType =
	(typeof SURVEY_PARTICIPANTS_CONFIG.VIEW_TYPES)[keyof typeof SURVEY_PARTICIPANTS_CONFIG.VIEW_TYPES];
export type SurveyAccess =
	(typeof SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS)[keyof typeof SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS];
